import { DataFieldWithDataType } from '../../types';
import { ApiValueDataType } from '../types';
import { toValue } from '../utils';
import { Employee, EmployeeProfileData } from './types';

export const showEmployee = (emp: Employee) =>
  `${emp.localFullName ?? emp.fullName ?? emp.id}${emp.jobTitle ? ` - ${emp.jobTitle}` : ''}`;

export const employeeTypeDataMapper = (
  data: ApiValueDataType[][] | null
): Employee[] => {
  return (
    data?.map((employee) => {
      console.log2('employeeTypeDataMapper', employee);
      return {
        id: toValue(employee[0] ?? null) as string,
        companyEmail: toValue(employee[1] ?? null) as string,
        firstName: toValue(employee[2] ?? null) as string,
        lastName: toValue(employee[3] ?? null) as string,
        fullName: toValue(employee[4] ?? null) as string,
        localFullName: toValue(employee[5] ?? null) as string,
        localFirstName: toValue(employee[6] ?? null) as string,
        localLastName: toValue(employee[7] ?? null) as string,
        preferredName: toValue(employee[8] ?? null) as string,
        localPreferredName: toValue(employee[9] ?? null) as string,
        jobTitle: toValue(employee[10] ?? null) as string,
      };
    }) ?? []
  );
};

export const employeeProfileTypeDataMapper = (
  data: ApiValueDataType[][] | null,
  fields: DataFieldWithDataType[],
  valueFormatter: (
    field: DataFieldWithDataType,
    value: string | undefined
  ) => string | null
): EmployeeProfileData[] => {
  return (
    data?.map((employee) => {
      return {
        fullName: valueFormatter(
          fields[0],
          toValue(employee[0]) as string | undefined
        ),
        employeeId: valueFormatter(fields[1], toValue(employee[1]) as string),
        joiningAgeGroup: valueFormatter(
          fields[2],
          toValue(employee[2]) as string | undefined
        ),
        locationLevel1: valueFormatter(
          fields[3],
          toValue(employee[3]) as string | undefined
        ),
        locationLevel2: valueFormatter(
          fields[4],
          toValue(employee[4]) as string | undefined
        ),
        locationLevel3: valueFormatter(
          fields[5],
          toValue(employee[5]) as string | undefined
        ),
        organizationLevel1: valueFormatter(
          fields[6],
          toValue(employee[6]) as string | undefined
        ),
        organizationLevel2: valueFormatter(
          fields[7],
          toValue(employee[7]) as string | undefined
        ),
        jobTitle: valueFormatter(
          fields[8],
          toValue(employee[8]) as string | undefined
        ),
        jobGradeLevel1: valueFormatter(
          fields[9],
          toValue(employee[9]) as string | undefined
        ),
        jobGradeLevel2: valueFormatter(
          fields[10],
          toValue(employee[10]) as string | undefined
        ),
        jobGradeLevel3: valueFormatter(
          fields[11],
          toValue(employee[11]) as string | undefined
        ),
        startDate: valueFormatter(
          fields[12],
          toValue(employee[12]) as string | undefined
        ),
        termDate: valueFormatter(
          fields[13],
          toValue(employee[13]) as string | undefined
        ),
        baseSalary: valueFormatter(
          fields[14],
          toValue(employee[14]) as string | undefined
        ),
        baseSalaryCurrency: valueFormatter(
          fields[15],
          toValue(employee[15]) as string | undefined
        ),
        baseSalaryFrequency: valueFormatter(
          fields[16],
          toValue(employee[16]) as string | undefined
        ),
        baseSalaryPerYear: valueFormatter(
          fields[17],
          toValue(employee[17]) as string | undefined
        ),
        annualCashBonus1: valueFormatter(
          fields[18],
          toValue(employee[18]) as string | undefined
        ),
        annualCashBonus1Currency: valueFormatter(
          fields[19],
          toValue(employee[19]) as string | undefined
        ),
        icr: valueFormatter(
          fields[20],
          toValue(employee[20]) as string | undefined
        ),
        performanceRating: valueFormatter(
          fields[21],
          toValue(employee[21]) as string | undefined
        ),
      };
    }) ?? []
  );
};
